import { cn } from "@/lib/utils";

export type ReportsNavItem = {
  value: string;
  label: string;
  description?: string;
};

type NavRowConfig = {
  items: readonly ReportsNavItem[];
  value: string;
  onChange: (value: string) => void;
  columns?: 2 | 3 | 4;
  label?: string;
  compact?: boolean;
};

type ReportsSectionNavProps = {
  primary: NavRowConfig;
  secondary?: NavRowConfig;
};

function NavPillRow({
  items,
  value,
  onChange,
  columns = 2,
  label,
  compact = false,
}: NavRowConfig) {
  const smGridClass =
    columns === 4
      ? "sm:grid-cols-4"
      : columns === 3
        ? "sm:grid-cols-3"
        : "sm:grid-cols-2";

  return (
    <div className="flex flex-col gap-2">
      {label ? (
        <span className="font-medium text-foreground text-xs">{label}</span>
      ) : null}
      <div
        className={cn(
          "flex gap-1 overflow-x-auto rounded-xl border border-border bg-muted/30 p-1 sm:grid sm:overflow-visible",
          smGridClass,
        )}
      >
        {items.map((item) => (
          <button
            key={item.value}
            type="button"
            onClick={() => onChange(item.value)}
            className={cn(
              "shrink-0 rounded-lg font-medium transition-colors sm:shrink",
              compact ? "px-3 py-1.5 text-xs" : "px-3 py-2.5 text-sm",
              value === item.value
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function ReportsSectionNav({
  primary,
  secondary,
}: ReportsSectionNavProps) {
  const activeItem =
    (secondary
      ? secondary.items.find((i) => i.value === secondary.value)
      : undefined) ?? primary.items.find((i) => i.value === primary.value);

  return (
    <div className="brand-card flex flex-col gap-3 p-3 sm:p-4">
      <NavPillRow
        {...primary}
        columns={primary.columns ?? (primary.items.length as 2 | 3 | 4)}
      />
      {secondary ? (
        <div className="border-secondary/10 border-t pt-3">
          <NavPillRow
            {...secondary}
            columns={secondary.columns ?? (secondary.items.length as 2 | 3 | 4)}
            compact
            label={secondary.label ?? "ປະເພດສິນຄ້າ"}
          />
        </div>
      ) : null}
      {activeItem?.description ? (
        <p className="border-secondary/10 border-t pt-3 text-muted-foreground text-xs">
          {activeItem.description}
        </p>
      ) : null}
    </div>
  );
}
